import React, { useRef, useState } from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { FileInput, CloudUpload, FileSpreadsheet, Send } from "lucide-react";

const fileTypes = ".xls,.xlsx";

const fileLabels = [
    { label: "Arquivo de Clientes", key: "clientes" },
    { label: "Arquivo de Pedidos", key: "pedidos" },
    { label: "Arquivo de Estoque", key: "estoque" },
];

export default function ImportData() {
    const [files, setFiles] = useState({
        clientes: null,
        pedidos: null,
        estoque: null,
    });

    const fileRefs = {
        clientes: useRef(),
        pedidos: useRef(),
        estoque: useRef(),
    };

    const handleFileChange = (e, key) => {
        setFiles({ ...files, [key]: e.target.files[0] });
    };

    const handleImport = (key) => {
        // lógica de importação individual
        // ...implementar integração...
        alert(`Importar: ${fileLabels.find(f => f.key === key).label}`);
    };

    const handleImportAll = () => {
        // lógica de importação em lote
        // ...implementar integração...
        alert("Importar Todos os Produtos");
    };

    return (
        <div style={{
            minHeight: "100vh",
            width: "80vw",
            background: "#8fd0ff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}>
            <div style={{
                width: "80%",
                background: "#fff",
                borderRadius: 16,
                boxShadow: "0 4px 24px #0002",
                padding: 2,
                textAlign: "center"
            }}>
                <div style={{ marginBottom: 16 }}>
                    <CloudUpload size={48} color="#3b82f6" style={{ marginBottom: 8 }} />
                    <h1 style={{ fontWeight: 700, fontSize: 32, margin: 0 }}>Upload de Arquivos XLS</h1>
                    <div style={{ color: "#6b7280", fontSize: 15, marginTop: 4 }}>
                        Selecione até 3 arquivos XLS/XLSX para importar.
                    </div>
                </div>
                <div>
                    {fileLabels.map(({ label, key }) => (
                        <Card key={key} style={{ marginBottom: 20, textAlign: "left", boxShadow: "0 2px 8px #0001" }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <FileSpreadsheet size={28} color="#3b82f6" style={{ marginRight: 12 }} />
                                <div>
                                    <div style={{ fontWeight: 600 }}>{label} <span style={{ fontWeight: 400, color: "#6b7280" }}>(XLS/XLSX)</span></div>
                                    <div style={{ display: "flex", alignItems: "center", marginTop: 8 }}>
                                        <input
                                            type="file"
                                            accept={fileTypes}
                                            ref={fileRefs[key]}
                                            style={{ display: "none" }}
                                            onChange={e => handleFileChange(e, key)}
                                        />
                                        <Button
                                            label="Escolher Arquivo"
                                            icon={<FileInput size={16} />}
                                            className="p-button-text"
                                            style={{ marginRight: 12, padding: "4px 12px" }}
                                            onClick={() => fileRefs[key].current.click()}
                                        />
                                        <span style={{ color: "#6b7280", fontSize: 14, flex: 1 }}>
                                            {files[key]?.name || "Nenhum arquivo escolhido"}
                                        </span>
                                        <Button
                                            label="Importar"
                                            icon={<Send size={16} />}
                                            style={{
                                                marginLeft: 12,
                                                background: "#93b3f7",
                                                border: "none",
                                                color: "#fff",
                                                fontWeight: 600,
                                                padding: "6px 18px"
                                            }}
                                            disabled={!files[key]}
                                            onClick={() => handleImport(key)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Card>
                    ))}
                </div>
                <Divider />
                <Button
                    label="Importar Todos os Produtos"
                    icon={<CloudUpload size={18} />}
                    style={{
                        width: "100%",
                        background: "#6fdc9c",
                        border: "none",
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: 17,
                        padding: "14px 0",
                        marginBottom: 24
                    }}
                    onClick={handleImportAll}
                    disabled={!files.clientes && !files.pedidos && !files.estoque}
                />
            </div>
        </div>
    );
}
